import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { InternalService } from './internal.service';

@Injectable({
  providedIn: 'root',
})
export class YmtGuard implements CanActivate {
  constructor(private authService: AuthService, private internalService: InternalService) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return combineLatest([this.internalService.isInternal$, this.authService.userInfo$.pipe(filter((v) => !!v))]).pipe(
      map(([isInternal, userInfo]) => isInternal || userInfo.isYMTEnabled),
    );
  }
}
